/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { Button, Table } from "semantic-ui-react";
import { TextField, Checkbox } from '@mui/material';
import { globalLoadingOff, globalLoadingOn } from "../slices/globalLoading/globalLoadingSlice";
import { selectEditMode } from "../slices/editMode/editModeSlice";
import { selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import { useEffect, useState } from "react";
import { changeTopNavigationElements } from "../slices/navigationPanel/navigationPanelSlice";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../slices/footer/footerSlice";
import getValueSetConceptsFromCodeSystemTerms from "../functions/getValueSetConceptsFromCodeSystemTermsAPI";
import updateElement from "../functions/updateElement";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";
import UriEntry, { DisplayFromFHIRUri } from "../datatypeComponents/UriEntry";
import StringEntry from "../datatypeComponents/StringEntry";
import CodingEntry from "../datatypeComponents/CodingEntry";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import Spinner from "../components/Spinner";

import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../slices/viewingOlderVersion/viewingOlderVersionSlice";

const ValueSetComposeEntry = ({ elementName, fieldLabel, startingValue, setResourceState }) => {
    let startingValueSetCompose = { lockedDate: "", inactive: "", include: [], exclude: [], property: [] };

    const [valueSetComposeState, setValueSetComposeState] = useState({});

    useEffect(() => {
        if (startingValue) {
            if (startingValue.extension) { startingValueSetCompose.extension = startingValue.extension; }
            if (startingValue.lockedDate) { startingValueSetCompose.lockedDate = startingValue.lockedDate; }
            if (typeof startingValue.inactive === "boolean") { startingValueSetCompose.inactive = startingValue.inactive; }
            if (startingValue.include) { startingValueSetCompose.include = startingValue.include; }
            if (startingValue.exclude) { startingValueSetCompose.exclude = startingValue.exclude; }
            if (startingValue.property) { startingValueSetCompose.property = startingValue.property; }
        }
        setValueSetComposeState(JSON.parse(JSON.stringify(startingValueSetCompose)));
    }, []);

    useEffect(() => {
        if (Object.keys(valueSetComposeState).length) {
            let newValueSetCompose = {};
            if (valueSetComposeState.extension) { newValueSetCompose.extension = valueSetComposeState.extension; }
            if (valueSetComposeState.lockedDate) { newValueSetCompose.lockedDate = valueSetComposeState.lockedDate; }
            if (typeof valueSetComposeState.inactive === "boolean") { newValueSetCompose.inactive = valueSetComposeState.inactive; }
            if (Array.isArray(valueSetComposeState.include) && valueSetComposeState.include.length > 0) {
                newValueSetCompose.include = valueSetComposeState.include;
            }
            if (Array.isArray(valueSetComposeState.exclude) && valueSetComposeState.exclude.length > 0) {
                newValueSetCompose.exclude = valueSetComposeState.exclude;
            }
            if (Array.isArray(valueSetComposeState.property) && valueSetComposeState.property.length > 0) {
                newValueSetCompose.property = valueSetComposeState.property;
            }
            if (Object.keys(newValueSetCompose).length === 0) {
                newValueSetCompose = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newValueSetCompose }; });
        }
    }, [valueSetComposeState]);

    if (Object.keys(valueSetComposeState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <ArrayEntry datatype='ValueSetComposeInclude' elementName='include' fieldLabel='Include'
                    deletable={true} startingValue={valueSetComposeState.include}
                    setResourceState={setValueSetComposeState} />
                <ArrayEntry datatype='ValueSetComposeInclude' elementName='exclude' fieldLabel='Exclude'
                    deletable={true} deletableArray={true} startingValue={valueSetComposeState.exclude}
                    startEmptyArrayClosed={true}
                    setResourceState={setValueSetComposeState} />
            </div>
        </>
    }
}

const importTermsToValueSet = async (apiToken, valueSetComposeIncludeState, setValueSetComposeIncludeState,
    codeSystemTermConversionState, setCodeSystemTermConversionState, dispatch) => {
    let system = valueSetComposeIncludeState.system;
    let anchor = system.split("#")[1] || "";

    let codeSystemFevirId;
    if (system?.substring(0, 39) === 'https://fevir.net/resources/CodeSystem/') {
        codeSystemFevirId = system.substring(39);
        if (codeSystemFevirId.split("#")[0] === "293778") {
            system = 'https://fevir.net/sevco';
            if (anchor) {
                system += "#" + anchor;
            }
        }
    } else if (system?.substring(0, 23) === 'https://fevir.net/sevco') {
        codeSystemFevirId = "293778";
        //system = 'https://fevir.net/resources/CodeSystem/' + codeSystemFevirId
        if (anchor) {
            codeSystemFevirId += "#" + anchor;
            system += "#" + anchor;
        }
    }

    if (codeSystemFevirId) {
        //setLoadingState(true);
        dispatch(globalLoadingOn());

        let termCode = codeSystemTermConversionState.termcode;

        if (!termCode && codeSystemFevirId.includes("#")) {
            [codeSystemFevirId, termCode] = codeSystemFevirId.split("#");
            system = system.split("#")[0];
        }

        let valueSetIncludeInstance = await getValueSetConceptsFromCodeSystemTerms(codeSystemFevirId,
            termCode, codeSystemTermConversionState.recursive, apiToken);
        //setLoadingState(false);
        dispatch(globalLoadingOff());
        let codecode = codeSystemTermConversionState.termcode;
        if (codecode === "") {
            codecode = "TOP";
        }
        if (valueSetIncludeInstance) {
            if (valueSetIncludeInstance.concept?.length > 0) {
                setCodeSystemTermConversionState(prevState => {
                    return {
                        ...prevState,
                        system: valueSetIncludeInstance.system,
                        version: valueSetIncludeInstance.version,
                        concept: valueSetIncludeInstance.concept
                    };
                });
                if (system !== valueSetComposeIncludeState.system) {
                    setValueSetComposeIncludeState(prevState => {
                        return {
                            ...prevState,
                            system: system,
                            termcode: termCode
                        };
                    });
                }
            } else {
                alert("That term doesn't have any child terms.")
            }
        } else {
            alert("Term import failed. Perhaps due to not finding the CodeSystem or code.");
        }
    } else {
        alert("System URL field can't be blank and it needs to start with https://fevir.net/resources/CodeSystem/.");
    }
}

const ValueSetComposeIncludeEntry = ({ elementName, fieldLabel, startingValue, setResourceState }) => {
    const dispatch = useDispatch();

    const apiToken = useSelector(selectCurrentUserApiToken);
    const [valueSetComposeIncludeState, setValueSetComposeIncludeState] = useState({});
    const [codeSystemTermConversionState, setCodeSystemTermConversionState] = useState({});
    const [directConceptEntryState, setDirectConceptEntryState] = useState(false);

    useEffect(() => {
        let startingValueSetComposeInclude = { system: "", version: "", concept: [], filter: [], valueSet: [], copyright: "" };
        let containsConcepts = false;
        if (!startingValue) {
            startingValueSetComposeInclude = { concept: [] };
        } else {
            if (startingValue.extension) { startingValueSetComposeInclude.extension = startingValue.extension; }
            if (startingValue.system) { startingValueSetComposeInclude.system = startingValue.system; }
            if (startingValue.version) { startingValueSetComposeInclude.version = startingValue.version; }
            if (startingValue.concept) {
                startingValueSetComposeInclude.concept = startingValue.concept;
                if (startingValue.concept.length > 0) {
                    containsConcepts = true;
                }
            }
            if (startingValue.filter) { startingValueSetComposeInclude.filter = startingValue.filter; }
            if (startingValue.valueSet) { startingValueSetComposeInclude.valueSet = startingValue.valueSet; }
            if (startingValue.copyright) { startingValueSetComposeInclude.copyright = startingValue.copyright; }
        }
        let startingCodeSystemTermConversionState = {
            'resourceid': "",
            'system': "",
            'version': "",
            'concept': [],
            'termcode': "",
            'recursive': false
        }
        if (valueSetComposeIncludeState.system?.substring(0, 39) === 'https://fevir.net/resources/CodeSystem/') {
            let codeSystemFevirId = valueSetComposeIncludeState.system.substring(39);
            startingCodeSystemTermConversionState["resourceid"] = codeSystemFevirId;
        }
        if (valueSetComposeIncludeState.version) {
            startingCodeSystemTermConversionState["version"] = valueSetComposeIncludeState.version;
        }
        setValueSetComposeIncludeState(JSON.parse(JSON.stringify(startingValueSetComposeInclude)));
        setCodeSystemTermConversionState(JSON.parse(JSON.stringify(startingCodeSystemTermConversionState)));
        setDirectConceptEntryState(containsConcepts);
    }, []);

    useEffect(() => {
        if (Object.keys(valueSetComposeIncludeState).length) {
            let newValueSetComposeInclude = {};
            if (valueSetComposeIncludeState.extension) { newValueSetComposeInclude.extension = valueSetComposeIncludeState.extension; }
            if (valueSetComposeIncludeState.system) {
                newValueSetComposeInclude.system = valueSetComposeIncludeState.system;
            }
            if (valueSetComposeIncludeState.version) {
                newValueSetComposeInclude.version = valueSetComposeIncludeState.version;
            }
            if (Array.isArray(valueSetComposeIncludeState.concept) && valueSetComposeIncludeState.concept.length > 0) {
                newValueSetComposeInclude.concept = valueSetComposeIncludeState.concept;
            }
            if (Array.isArray(valueSetComposeIncludeState.filter) && valueSetComposeIncludeState.filter.length > 0) {
                newValueSetComposeInclude.filter = valueSetComposeIncludeState.filter;
            }
            if (Array.isArray(valueSetComposeIncludeState.valueSet) && valueSetComposeIncludeState.valueSet.length > 0) {
                newValueSetComposeInclude.valueSet = valueSetComposeIncludeState.valueSet;
            }
            if (valueSetComposeIncludeState.copyright) { newValueSetComposeInclude.copyright = valueSetComposeIncludeState.copyright; }
            if (Object.keys(newValueSetComposeInclude).length === 0) {
                newValueSetComposeInclude = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newValueSetComposeInclude }; });
        }
    }, [valueSetComposeIncludeState]);

    useEffect(() => {
        if (codeSystemTermConversionState.system && codeSystemTermConversionState.concept.length > 0) {
            setDirectConceptEntryState(true);
            setValueSetComposeIncludeState(prevState => {
                return {
                    ...prevState,
                    version: codeSystemTermConversionState.version,
                    concept: codeSystemTermConversionState.concept
                };
            });
        }
    }, [codeSystemTermConversionState])

    if (Object.keys(valueSetComposeIncludeState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <UriEntry elementName='system' fieldLabel='Code System'
                    startingValue={valueSetComposeIncludeState.system} setResourceState={setValueSetComposeIncludeState} />
                <StringEntry elementName='version' fieldLabel='Version'
                    startingValue={valueSetComposeIncludeState.version} setResourceState={setValueSetComposeIncludeState} />
                {(!valueSetComposeIncludeState.concept || valueSetComposeIncludeState.concept.length === 0 ||
                    (valueSetComposeIncludeState.concept.length === 1 && valueSetComposeIncludeState.concept[0].code === ""))
                    &&
                    <>
                        <div>
                            <br /><br />
                            <span>
                                <b>Term Code: </b>
                                <TextField style={{ width: "160px" }} multiline className="inputField" type='text' label={''} size="small"
                                    variant='outlined' value={codeSystemTermConversionState.termcode}
                                    onChange={(e) => {
                                        setCodeSystemTermConversionState(prevState => { return { ...prevState, "termcode": e.target.value } });
                                    }} />
                            </span>
                            <span style={{ paddingLeft: "12px" }}>
                                <Checkbox checked={codeSystemTermConversionState.recursive}
                                    onChange={(e) => {
                                        setCodeSystemTermConversionState(prevState => { return { ...prevState, "recursive": e.target.checked } });
                                    }}
                                    color="primary"
                                    style={{ paddingLeft: "0px", paddingRight: "4px" }}
                                /><>Recursive Children</>
                            </span>
                            <span style={{ paddingLeft: "12px" }}>
                                <Button className="formButton" style={{ color: "#000000" }}
                                    content="Import Terms From CodeSystem"
                                    onClick={() => {
                                        importTermsToValueSet(apiToken, valueSetComposeIncludeState, setValueSetComposeIncludeState,
                                            codeSystemTermConversionState, setCodeSystemTermConversionState, dispatch);
                                    }}
                                />
                                <>&nbsp;&nbsp;</>
                                <Button className="formButton" style={{ color: "#000000" }}
                                    content="Add Concepts Individually"
                                    onClick={() => { setDirectConceptEntryState(true); }}
                                />
                            </span>
                        </div>
                    </>
                }
                {directConceptEntryState &&
                    <ArrayEntry datatype='ValueSetComposeIncludeConcept'
                        elementName='concept' fieldLabel='Concept'
                        startEmptyArrayClosed={true} deletable={true} deletableArray={true}
                        startingValue={Array.isArray(valueSetComposeIncludeState.concept) && valueSetComposeIncludeState.concept.length ? valueSetComposeIncludeState.concept : [{}]}
                        setResourceState={setValueSetComposeIncludeState} />
                }
            </div>
        </>
    }
}

const ValueSetComposeIncludeConceptEntry = ({ elementName, fieldLabel, startingValue, setResourceState, dataEntryStyle }) => {

    const [valueSetComposeIncludeConceptState, setValueSetComposeIncludeConceptState] = useState({});

    useEffect(() => {
        let startingValueSetConcept = { code: "", display: "", designation: [] };
        if (startingValue) {
            if (startingValue.extension) { startingValueSetConcept.extension = startingValue.extension; }
            if (startingValue.code) { startingValueSetConcept.code = startingValue.code; }
            if (startingValue.display) { startingValueSetConcept.display = startingValue.display; }
            if (startingValue.designation) { startingValueSetConcept.designation = startingValue.designation; }
        }
        setValueSetComposeIncludeConceptState(JSON.parse(JSON.stringify(startingValueSetConcept)));
    }, []);

    useEffect(() => {
        if (Object.keys(valueSetComposeIncludeConceptState).length > 0) {
            let newValueSetConcept = {};
            if (valueSetComposeIncludeConceptState.extension) { newValueSetConcept.extension = valueSetComposeIncludeConceptState.extension; }
            if (valueSetComposeIncludeConceptState.code) { newValueSetConcept.code = valueSetComposeIncludeConceptState.code; }
            if (valueSetComposeIncludeConceptState.display) { newValueSetConcept.display = valueSetComposeIncludeConceptState.display; }
            if (Array.isArray(valueSetComposeIncludeConceptState.designation) && valueSetComposeIncludeConceptState.designation.length > 0) {
                newValueSetConcept.designation = valueSetComposeIncludeConceptState.designation;
            }
            if (Object.keys(newValueSetConcept).length === 0) {
                newValueSetConcept = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newValueSetConcept }; });
        }
    }, [valueSetComposeIncludeConceptState]);

    if (Object.keys(valueSetComposeIncludeConceptState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <StringEntry elementName='code' fieldLabel='Code'
                    startingValue={valueSetComposeIncludeConceptState.code} setResourceState={setValueSetComposeIncludeConceptState} />
                <StringEntry elementName='display' fieldLabel='Display'
                    startingValue={valueSetComposeIncludeConceptState.display} setResourceState={setValueSetComposeIncludeConceptState} />
                <ArrayEntry datatype='ConceptDesignation' elementName='designation'
                    fieldLabel='Designation' startEmptyArrayClosed={true}
                    deletable={true} deletableArray={true}
                    startingValue={valueSetComposeIncludeConceptState.designation}
                    setResourceState={setValueSetComposeIncludeConceptState} />
            </div>
        </>
    }
}

const conceptDesignationDotUseValueSet = [
    { system: "http://snomed.info/sct", code: "900000000000550004", display: "Definition (core metadata concept)" },
    { system: "http://snomed.info/sct", code: "900000000000013009", display: "Synonym (core metadata concept)" }
]
const ConceptDesignationEntry = ({ elementName, fieldLabel, startingValue, setResourceState, dataEntryStyle }) => {

    const [conceptDesignationState, setConceptDesignationState] = useState({});

    useEffect(() => {
        let startingConceptDesignation = { language: "", use: "", additionalUse: [], value: "" };
        if (startingValue) {
            if (startingValue.extension) { startingConceptDesignation.extension = startingValue.extension; }
            if (startingValue.language) { startingConceptDesignation.language = startingValue.language; }
            if (startingValue.use) { startingConceptDesignation.use = startingValue.use; }
            if (startingValue.additionalUse) { startingConceptDesignation.additionalUse = startingValue.additionalUse; }
            if (startingValue.value) { startingConceptDesignation.value = startingValue.value; }
        }
        setConceptDesignationState(JSON.parse(JSON.stringify(startingConceptDesignation)));
    }, []);

    useEffect(() => {
        if (Object.keys(conceptDesignationState).length) {
            let newConceptDesignation = {};
            if (conceptDesignationState.extension) { newConceptDesignation.extension = conceptDesignationState.extension; }
            if (conceptDesignationState.language) { newConceptDesignation.language = conceptDesignationState.language; }
            if (conceptDesignationState.use && Object.keys(conceptDesignationState.use).length > 0) { newConceptDesignation.use = conceptDesignationState.use; }
            if (Array.isArray(conceptDesignationState.additionalUse) && conceptDesignationState.additionalUse.length > 0) {
                newConceptDesignation.additionalUse = conceptDesignationState.additionalUse;
            }
            if (conceptDesignationState.value) { newConceptDesignation.value = conceptDesignationState.value; }
            if (Object.keys(newConceptDesignation).length === 0) {
                newConceptDesignation = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newConceptDesignation }; });
        }
    }, [conceptDesignationState]);

    if (Object.keys(conceptDesignationState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodingEntry elementName='use' fieldLabel='Use'
                    valueSet={conceptDesignationDotUseValueSet}
                    startingValue={conceptDesignationState.use} setResourceState={setConceptDesignationState} />
                <StringEntry elementName='value' fieldLabel='Value'
                    startingValue={conceptDesignationState.value} setResourceState={setConceptDesignationState} />
            </div>
        </>
    }
}

const ValueSetDisplay = ({ foi }) => {
    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const displayTitle = parentResourceDetail?.displayTitle;
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));

    const [valueSetResourceState, setValueSetResourceState] = useState({});
    const [scopeState, setScopeState] = useState({});
    //const [loadingState, setLoadingState] = useState(false);

    useEffect(() => {
        dispatch(changeTopNavigationElements(["Description", "Content"]));
        dispatch(changeBrowserTabTitle("FEvIR ValueSet - " + displayTitle));
        if (viewingOlderVersion && olderVersionFhirString) {
            try {
                const olderVersionJson = JSON.parse(olderVersionFhirString);
                setValueSetResourceState(olderVersionJson);
                setScopeState({
                    "inclusionCriteria": olderVersionJson.scope?.inclusionCriteria || "",
                    "exclusionCriteria": olderVersionJson.scope?.exclusionCriteria || ""
                });
            } catch {
                alert("Error viewing JSON of older version.");
            }
        } else if (resourceJson) {
            let newResourceJson = JSON.parse(JSON.stringify(resourceJson));
            if (!newResourceJson.compose) {
                newResourceJson.compose = { "include": [{}] };
            } else if (!newResourceJson.compose.include?.length) {
                newResourceJson.compose.include = [{}];
            }
            setValueSetResourceState(newResourceJson); //TODO todo, is it a problem we made a copy of the resourceJson? Was it meant to be the same object?
            setScopeState({
                "inclusionCriteria": newResourceJson.scope?.inclusionCriteria || "",
                "exclusionCriteria": newResourceJson.scope?.exclusionCriteria || ""
            });
        }
    }, [resourceJson]);

    useEffect(() => {
        dispatch(changeTool("FEvIR®: ValueSet " + (editMode ? "Builder" : "Viewer")));
    }, [editMode]);

    useEffect(() => {
        if (Object.keys(scopeState).length > 0) {
            let newScope = {};
            if (scopeState.extension) { newScope.extension = scopeState.extension; }
            if (scopeState.inclusionCriteria) { newScope.inclusionCriteria = scopeState.inclusionCriteria; }
            if (scopeState.exclusionCriteria) { newScope.exclusionCriteria = scopeState.exclusionCriteria; }
            if (Object.keys(newScope).length === 0) {
                newScope = null;
            }
            setValueSetResourceState(prevState => { return { ...prevState, "scope": newScope } });
        }
    }, [scopeState]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(valueSetResourceState, "title", "string", parentResourceDetail,
                dispatch);
        }
    }, [valueSetResourceState.title]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(valueSetResourceState, "version", "string", parentResourceDetail,
                dispatch);
        }
    }, [valueSetResourceState.version]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(valueSetResourceState, "description", "markdown", parentResourceDetail,
                dispatch);
        }
    }, [valueSetResourceState.description]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(valueSetResourceState, "scope", "ValueSetScope", parentResourceDetail,
                dispatch);
        }
    }, [valueSetResourceState.scope]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(valueSetResourceState, "copyright", "markdown", parentResourceDetail,
                dispatch);
        }
    }, [valueSetResourceState.copyright]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(valueSetResourceState, "compose", "ValueSetCompose", parentResourceDetail,
                dispatch);
        }
    }, [valueSetResourceState.compose]);

    if (!resourceJson) {
        return <Spinner />;
    }

    return <div>
        {valueSetResourceState.id && <>
            <div>
                <div style={{ marginTop: "12px" }}>
                    <h3 id="description">ValueSet Description</h3>
                    <div style={{ marginLeft: "24px" }}>
                        {editMode ?
                            <>
                                <StringEntry elementName='title' fieldLabel='Title'
                                    startingValue={valueSetResourceState.title}
                                    setResourceState={setValueSetResourceState} />
                            </>
                            :
                            <>
                                {valueSetResourceState.title && <p><b>Title: </b>{valueSetResourceState.title}</p>}
                            </>
                        }
                        {editMode ?
                            <>
                                <StringEntry elementName='version' fieldLabel='Version'
                                    startingValue={valueSetResourceState.version}
                                    setResourceState={setValueSetResourceState} />
                            </>
                            :
                            <>
                                {valueSetResourceState.version && <p><b>Version: </b>{valueSetResourceState.version}</p>}
                            </>
                        }
                        {editMode ?
                            <>
                                <MarkdownEntry elementName='description' fieldLabel='Description'
                                    startingValue={valueSetResourceState.description}
                                    setResourceState={setValueSetResourceState} />
                            </>
                            :
                            <>
                                {valueSetResourceState.description &&
                                    <div>
                                        <b>Description: </b><DisplayFromFHIRMarkdown markdown={valueSetResourceState.description} />
                                        <br /><br />
                                    </div>}
                            </>
                        }
                        {editMode ?
                            <>
                                <MarkdownEntry elementName='inclusionCriteria' fieldLabel='Inclusion Criteria'
                                    startingValue={scopeState.inclusionCriteria} setResourceState={setScopeState} />
                            </>
                            :
                            <>
                                {valueSetResourceState.scope?.inclusionCriteria &&
                                    <div>
                                        <b>Inclusion Criteria: </b><DisplayFromFHIRMarkdown markdown={valueSetResourceState.scope.inclusionCriteria} />
                                    </div>}
                            </>
                        }
                        {editMode ?
                            <>
                                <MarkdownEntry elementName='exclusionCriteria' fieldLabel='Exclusion Criteria'
                                    startingValue={scopeState.exclusionCriteria} setResourceState={setScopeState} />
                            </>
                            :
                            <>
                                {valueSetResourceState.scope?.exclusionCriteria &&
                                    <div>
                                        <b>Exclusion Criteria: </b><DisplayFromFHIRMarkdown markdown={valueSetResourceState.scope.exclusionCriteria} />
                                    </div>}
                            </>
                        }
                        {editMode ?
                            <>
                                <MarkdownEntry elementName='copyright' fieldLabel='Copyright'
                                    startingValue={valueSetResourceState.copyright}
                                    setResourceState={setValueSetResourceState} />
                            </>
                            :
                            <>
                                {valueSetResourceState.copyright &&
                                    <div>
                                        <b>Copyright: </b><DisplayFromFHIRMarkdown markdown={valueSetResourceState.copyright} />
                                        <br /><br />
                                    </div>}
                            </>
                        }
                    </div>
                    <h3 id="content">Content</h3>
                    <div style={{ marginLeft: "24px" }}>
                        {editMode ?
                            <>
                                <ValueSetComposeEntry elementName='compose'
                                    fieldLabel='Compose (content logical definition)'
                                    startingValue={valueSetResourceState.compose}
                                    setResourceState={setValueSetResourceState} />
                            </>
                            :
                            <>
                                {valueSetResourceState.compose && <>
                                    {(Array.isArray(valueSetResourceState.compose.include) && valueSetResourceState.compose.include?.length > 0) && <>
                                        <h4>Included Values</h4>
                                        {valueSetResourceState.compose.include?.map((include, includeIndex) => {
                                            let includeStyle = {};
                                            if (valueSetResourceState.compose.include.length > 1) {
                                                includeStyle = { paddingLeft: "40px" };
                                            }
                                            let fevirSystemURL = "";
                                            let codeSystemFevirId = "";
                                            if (include.system?.substring(0, 39) === 'https://fevir.net/resources/CodeSystem/') {
                                                fevirSystemURL = include.system;
                                                codeSystemFevirId = include.system.substring(39);
                                            }
                                            if (include.system === 'https://fevir.net/sevco') {
                                                fevirSystemURL = include.system;
                                                codeSystemFevirId = "293778";
                                            }
                                            return <span key={includeIndex}>
                                                {valueSetResourceState.compose.include?.length > 1 &&
                                                    <h4>Code System {includeIndex + 1} of {valueSetResourceState.compose.include?.length}</h4>}
                                                <div style={includeStyle}>
                                                    <>
                                                        <p><b>System: </b>
                                                            {fevirSystemURL ?
                                                                <a href={fevirSystemURL}
                                                                    target="_blank" rel="noopener noreferrer">{fevirSystemURL}</a>
                                                                :
                                                                <>{include.system}</>
                                                            }
                                                        </p>
                                                        <p><b>Version: </b>{include.version}</p>
                                                    </>
                                                    {include.concept &&
                                                        <Table>
                                                            <Table.Header>
                                                                <Table.Row>
                                                                    <Table.HeaderCell>Code</Table.HeaderCell>
                                                                    <Table.HeaderCell>Display</Table.HeaderCell>
                                                                    <Table.HeaderCell>Definition</Table.HeaderCell>
                                                                    <Table.HeaderCell>Alternative Terms</Table.HeaderCell>
                                                                </Table.Row>
                                                            </Table.Header>
                                                            <Table.Body>
                                                                {include?.concept?.map((concept, conceptIndex) => {
                                                                    return <Table.Row key={conceptIndex}>
                                                                        <Table.Cell style={{ verticalAlign: "top", width: "15%" }}>
                                                                            {codeSystemFevirId
                                                                                ?
                                                                                <a href={"/resources/CodeSystem/" + codeSystemFevirId + "#" + concept.code}
                                                                                    target="blank">{concept.code}</a>
                                                                                :
                                                                                <>{concept.code}</>}
                                                                        </Table.Cell>
                                                                        <Table.Cell style={{ verticalAlign: "top", width: "20%" }}>
                                                                            {concept.display}
                                                                        </Table.Cell>
                                                                        <Table.Cell style={{ verticalAlign: "top", width: "50%" }}>
                                                                            {Array.isArray(concept.designation) &&
                                                                                concept.designation.filter(designation => (designation.use?.code === "900000000000550004" || designation.use?.display === "definition" || designation.use?.display === "Definition"))
                                                                                    .map(designation => { return designation.value }).join("; ")}
                                                                        </Table.Cell>
                                                                        <Table.Cell style={{ verticalAlign: "top", width: "15%" }}>
                                                                            {Array.isArray(concept.designation) &&
                                                                                concept.designation.filter(designation => (designation.use?.code === "900000000000013009" || designation.use.display === "Alternative term"))
                                                                                    .map(designation => { return designation.value }).join("; ")}
                                                                        </Table.Cell>
                                                                    </Table.Row>;
                                                                })
                                                                }
                                                            </Table.Body>
                                                        </Table>
                                                    }
                                                </div>
                                                <br />
                                            </span>
                                        })}
                                    </>}
                                    {(Array.isArray(valueSetResourceState.compose.exclude) && valueSetResourceState.compose.exclude.length > 0) && <>
                                        <br />
                                        <h4>Excluded Values</h4>
                                        {valueSetResourceState.compose.exclude.map((exclude, excludeIndex) => {
                                            let excludeStyle = {};
                                            if (valueSetResourceState.compose.exclude.length > 1) {
                                                excludeStyle = { paddingLeft: "40px" };
                                            }
                                            let fevirSystemURL = "";
                                            let codeSystemFevirId = "";
                                            if (exclude.system.substring(0, 39) === 'https://fevir.net/resources/CodeSystem/') {
                                                fevirSystemURL = exclude.system;
                                                codeSystemFevirId = exclude.system.substring(39);
                                            }
                                            if (exclude.system === 'https://fevir.net/sevco') {
                                                fevirSystemURL = exclude.system;
                                                codeSystemFevirId = "293778";
                                            }
                                            return <span key={excludeIndex}>
                                                {valueSetResourceState.compose.exclude.length > 1 &&
                                                    <h4>Code System {excludeIndex + 1} of {valueSetResourceState.compose.exclude.length}</h4>}
                                                <div style={excludeStyle}>
                                                    <>
                                                        <p><b>System: </b>
                                                            {fevirSystemURL ?
                                                                <a href={fevirSystemURL} target="_blank" rel="noopener noreferrer">{fevirSystemURL}</a>
                                                                :
                                                                <>{exclude.system}</>
                                                            }
                                                        </p>
                                                        <p><b>Version: </b>{exclude.version}</p>
                                                    </>
                                                    <Table>
                                                        <Table.Header>
                                                            <Table.Row>
                                                                <Table.HeaderCell>Code</Table.HeaderCell>
                                                                <Table.HeaderCell>Display</Table.HeaderCell>
                                                                <Table.HeaderCell>Definition</Table.HeaderCell>
                                                                <Table.HeaderCell>Alternative Terms</Table.HeaderCell>
                                                            </Table.Row>
                                                        </Table.Header>
                                                        <Table.Body>
                                                            {exclude.concept.map((concept, conceptIndex) => {
                                                                return <Table.Row key={conceptIndex}>
                                                                    <Table.Cell style={{ verticalAlign: "top", width: "15%" }}>
                                                                        {codeSystemFevirId
                                                                            ?
                                                                            <a href={"/resources/CodeSystem/" + codeSystemFevirId + "#" + concept.code}
                                                                                target="blank">{concept.code}</a>
                                                                            :
                                                                            <>{concept.code}</>}
                                                                    </Table.Cell>
                                                                    <Table.Cell style={{ verticalAlign: "top", width: "20%" }}>
                                                                        {concept.display}
                                                                    </Table.Cell>
                                                                    <Table.Cell style={{ verticalAlign: "top", width: "50%" }}>
                                                                        {Array.isArray(concept.designation) &&
                                                                            concept.designation.filter(designation => designation.use?.code === "900000000000550004")
                                                                                .map(designation => { return designation.value }).join("; ")}
                                                                    </Table.Cell>
                                                                    <Table.Cell style={{ verticalAlign: "top", width: "15%" }}>
                                                                        {Array.isArray(concept.designation) &&
                                                                            concept.designation.filter(designation => designation.use?.code === "900000000000013009")
                                                                                .map(designation => { return designation.value }).join("; ")}
                                                                    </Table.Cell>
                                                                </Table.Row>;
                                                            })
                                                            }
                                                        </Table.Body>
                                                    </Table>
                                                </div>
                                                <br />
                                            </span>
                                        })}
                                    </>}
                                </>}
                                {(Array.isArray(valueSetResourceState.expansion?.contains) && valueSetResourceState.expansion.contains.length > 0) &&
                                    <>
                                        <Table>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>System</Table.HeaderCell>
                                                    <Table.HeaderCell>Code</Table.HeaderCell>
                                                    <Table.HeaderCell>Display</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {valueSetResourceState.expansion.contains.map((concept, conceptIndex) => {
                                                    return <Table.Row key={conceptIndex}>
                                                        <Table.Cell style={{ verticalAlign: "top", width: "35%" }}>
                                                            <DisplayFromFHIRUri uri={concept.system} />
                                                        </Table.Cell>
                                                        <Table.Cell style={{ verticalAlign: "top", width: "30%" }}>
                                                            {concept.code}
                                                        </Table.Cell>
                                                        <Table.Cell style={{ verticalAlign: "top", width: "35%" }}>
                                                            {concept.display}
                                                        </Table.Cell>
                                                    </Table.Row>;
                                                })
                                                }
                                            </Table.Body>
                                        </Table></>}
                            </>
                        }
                    </div>
                </div>
            </div>
        </>}
    </div>
}

export default ValueSetDisplay;
export { ConceptDesignationEntry, ValueSetComposeIncludeEntry, ValueSetComposeIncludeConceptEntry };